import type { Query, QueryClient } from "@tanstack/react-query";

/**
 * Predicate to match balance-related queries
 * Used for invalidating all balance queries after transactions or override changes
 */
function isBalanceQuery(query: Query): boolean {
  return (
    Array.isArray(query.queryKey) &&
    (query.queryKey[0] === "balance" ||
      query.queryKey[0] === "token-balance" ||
      query.queryKey[0] === "native-balance" ||
      query.queryKey[0] === "balances")
  );
}

/**
 * Invalidate all balance-related queries
 * Reusable function for transactions and override changes
 */
export async function invalidateBalanceQueries(queryClient: QueryClient): Promise<void> {
  await queryClient.invalidateQueries({
    predicate: isBalanceQuery,
  });
}
